import { makeRequest } from '../lib/fetch';
import { apiActions, commonActions } from '../app/actions';
import { setIsFetching, setIsNotFetching } from '../ui/actions';
import { fireMessageEvent } from '../messenger/utils';

export const setSlotToOpen = (id) => (dispatch) => {
  const { setValue } = commonActions('slot_to_open');
  dispatch(setValue(id));
};

export const setSlotToClosed = (id) => (dispatch) => {
  const { setValue } = commonActions('slot_to_closed');
  dispatch(setValue(id));
};

export const setPlaceholderState = (resp) => (dispatch) => {
  const { setValue } = commonActions('placeholder_state');
  dispatch(setValue(resp));
};

export const setPlayerToPicked = (props) => (dispatch) => {
  const { setValue } = commonActions('player_to_picked');
  dispatch(setValue(props));
};

export const setRandomPlayerPicks = (props) => (dispatch) => {
  const { setValue } = commonActions('random_player_picks');
  dispatch(setValue(props));
};

export const setIncompletePicksModalToOpen = () => ({
  type: 'SET_INCOMPLETE_PICKS_MODAL_OPEN',
});

export const setIncompletePicksModalToClosed = () => ({
  type: 'SET_INCOMPLETE_PICKS_MODAL_CLOSED',
});

export const setPendingNavigation = (routeId) => ({
  type: 'SET_PENDING_NAVIGATION',
  payload: routeId,
});

export const clearPendingNavigation = () => ({
  type: 'CLEAR_PENDING_NAVIGATION',
});

export const resetNavigationModalState = () => ({
  type: 'RESET_NAVIGATION_MODAL_STATE',
});

export const clearAllPicks = () => ({
  type: 'CLEAR_ALL_PICKS',
});

export const handleModalLeave = () => (dispatch, getState) => {
  const state = getState();
  if (state.picks.pendingNavigation) {
    const targetRoute = state.picks.pendingNavigation;

    if (targetRoute === 'close') {
      dispatch(clearPendingNavigation());
      dispatch(setIncompletePicksModalToClosed());
      dispatch(clearAllPicks());

      const { config } = state;
      const { platform, env } = config;
      fireMessageEvent({ type: 'CLOSE_WINDOW', platform, env });
      return;
    }

    if (targetRoute === 'heatstreak') {
      dispatch(clearPendingNavigation());
      dispatch(setIncompletePicksModalToClosed());
      dispatch(clearAllPicks());

      const { setValue } = commonActions('heatstreak_panel_open');
      dispatch(setValue());
      return;
    }

    const routeById = state.routing.routeById;
    const targetPath = routeById[targetRoute]?.path;

    if (targetPath) {
      dispatch(clearPendingNavigation());
      dispatch(setIncompletePicksModalToClosed());
      dispatch(clearAllPicks());

      window.history.pushState({}, '', targetPath);
      window.dispatchEvent(new PopStateEvent('popstate'));
    } else {
      dispatch(clearPendingNavigation());
      dispatch(setIncompletePicksModalToClosed());
    }
  } else {
    dispatch(setIncompletePicksModalToClosed());
  }
};

export const sendPlayerPicks = () => (dispatch, getState) => {
  const { config, picks } = getState();
  const { apiUrl, graphqlUrl, language, env, userId, currentSession, platform } = config;
  const { picked } = picks;

  const { sendStart, sendSuccess, sendFailure } = apiActions('player_picks');

  dispatch(setIsFetching());
  dispatch(sendStart());

  const playerPicks = [
    {
      setId: '1',
      playerId: picked[1],
    },
    {
      setId: '2',
      playerId: picked[2],
    },
    {
      setId: '3',
      playerId: picked[3],
    },
  ];

  return makeRequest({
    route: 'playerPicks',
    data: { picks: playerPicks },
    apiUrl,
    graphqlUrl,
    language,
    platform,
    env,
    userId,
    currentSession,
  }).then(
    (resp) => {
      if ((resp.code && resp.code.includes('hc.')) || (resp.code && resp.code === 'serverError')) {
        dispatch(sendFailure(resp.code));
        return dispatch(setIsNotFetching());
      }

      const messageData = {
        route: 'playerPicks',
        picks,
        apiUrl,
        userId,
        currentSession,
      };
      fireMessageEvent({
        type: 'LOG',
        platform,
        title: 'hockey-challenge-picks-endpoint-success',
        data: messageData,
      });

      dispatch(sendSuccess());
      return dispatch(setIsNotFetching());
    },
    (err) => {
      if (err?.status === 401) {
        dispatch(apiActions('auth').fetchFailure());
        return dispatch(setIsNotFetching());
      }
      const messageData = {
        err,
        route: 'playerPicks',
        picks,
        apiUrl,
        userId,
        currentSession,
      };
      fireMessageEvent({
        type: 'ERROR',
        platform,
        title: 'hockey-challenge-error',
        data: messageData,
      });
      if (err.code === 500) {
        // trigger game crash modal
        dispatch(apiActions('data_500').fetchFailure(err));
      } else {
        dispatch(sendFailure(err));
      }
      return dispatch(setIsNotFetching());
    },
  );
};

export const clearSubmissionError = () => (dispatch) => {
  dispatch({
    type: 'CLEAR_SUBMISSION_ERROR',
  });
};
